// extracted by mini-css-extract-plugin
module.exports =  {"recent-progress":"Show-ypVz__recent-progress","chapters-overview":"Show-cFme__chapters-overview","no-group-tile":"Show-XtmV__no-group-tile"};